import { createAsyncThunk } from '@reduxjs/toolkit';
import { givePayCardList } from './service';

export const givePayCard = createAsyncThunk(
    'getPayCard',
    async (params, { rejectWithValue }) => {
        try {
            const response = await givePayCardList();
            return response.data;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
)
